import { render, staticRenderFns } from "./layout1.vue?vue&type=template&id=538fd883&scoped=true&"
import script from "./layout1.vue?vue&type=script&lang=js&"
export * from "./layout1.vue?vue&type=script&lang=js&"
import style0 from "./layout1.vue?vue&type=style&index=0&id=538fd883&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "538fd883",
  null
  
)

export default component.exports